import React, { useState } from 'react';

import { SvgIconNames } from '~/design-tokens/iconography/SvgIcons';

import { LogoImage } from './components/logo-image/LogoImage';
import { LogoPlaceholder } from './components/logo-placeholder/LogoPlaceholder';

export const LogoTypes = {
  StockInitial: 'StockInitial',
  EquitySector: 'EquitySector',
  FinancialInstrument: 'FinancialInstrument',
  Crypto: 'Crypto',
  FxCurrency: 'FxCurrency',
  SubClass: 'SubClass',
  Default: 'Default',
};

export type LightEntity = {
  class: number;
  tag: string;
  name_short: string;
};

export interface AssetLogoProps {
  entity: LightEntity;
  type?: string;
  className?: string;
  size?: number;
  withFallback?: boolean;
  isNotStockEntity: boolean;
  isFiEntity: boolean;
  placeholderIconName: SvgIconNames;
  placeholderSubClassIcon: SvgIconNames;
  logoUrl?: string;
}

export const AssetLogo = ({
  entity,
  type,
  size = 32,
  className,
  isNotStockEntity,
  isFiEntity,
  placeholderIconName,
  placeholderSubClassIcon,
  withFallback = true,
  logoUrl,
}: AssetLogoProps) => {
  const [hasError, setHasError] = useState(false);

  const showFallbackLogo = !logoUrl || hasError || isNotStockEntity;

  if (showFallbackLogo) {
    return withFallback ? (
      <LogoPlaceholder
        iconName={placeholderIconName}
        subClassIcon={placeholderSubClassIcon}
        entity={entity}
        type={type}
        className={className}
        size={size}
      />
    ) : null;
  }

  return (
    <LogoImage
      isFiEntity={isFiEntity}
      entity={entity}
      className={className}
      logoUrl={logoUrl}
      onError={() => setHasError(true)}
      size={size}
    />
  );
};
